import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';

interface ProjectNameAdvisoryProps {
  children?: never;
  name: string;
}

/**
 *  Warn users about a potentially bad project name
 */
export function ProjectNameAdvisory({ name }: ProjectNameAdvisoryProps): JSX.Element {
  const { t } = useLang();

  return (
    <Column fullWidth>
      <p>{t('project-name-may-not-conform')}</p>

      <p className="mx-auto text-center">
        {t('name')}: <strong>{name}</strong>
      </p>

      <p>
        {t('please-refrain-special-chars')} <strong>{t('strictly-necessary')}</strong>
      </p>

      <p>{t('verify-any-missing-space')}</p>

      <p className="text-destructive">
        {t('remember, project-name')} <strong>{t('should-not-be-email-subject')}</strong>
      </p>
    </Column>
  );
}
